import { z } from 'zod';

export const SafeStringSchema = z.preprocess(
    (val) => (val === null ? '' : val),
    z.string().default('')
);